import { React } from 'react';
import getConfig from 'next/config';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import { Box, Skeleton, Typography } from '@mui/material';
import { GiftIcon } from '../shared/CustomIcons.styled';
import styles from '../eir-cart/styles';
import getGeneralImage from '../../../util/getGeneralImage';

const { publicRuntimeConfig } = getConfig();

const EirOfferDiscounts = ({ loading, description, value, cmsData }) => {
  const theme = useTheme();

  return !loading ? (
    <Box sx={styles(theme).offerDiscount}>
      <Stack direction='row' alignItems='center'>
        {cmsData?.GeneralImage_OrderSummary.length > 0 ? (
          <Box
            component='img'
            src={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
              getGeneralImage({
                generalImageArray: cmsData?.GeneralImage_OrderSummary,
                key: 'giftIcon',
                view: 'DesktopViewImage',
              }).url
            }`}
            alt=''
            style={{ width: '22.27px', height: '23.32px' }}
          />
        ) : (
          <GiftIcon sx={{ pt: '4px' }} />
        )}

        <Typography
          variant='body2'
          sx={{
            color: theme.palette.primary.textColor3,
            marginLeft: cmsData?.GeneralImage_OrderSummary.length > 0 && '8px',
          }}
        >
          {description} {value}
        </Typography>
      </Stack>
    </Box>
  ) : (
    <Skeleton variant='rectangular' width='100%' height='100%' />
  );
};
export default EirOfferDiscounts;
